import { render, staticRenderFns } from "./OfficesLogIn.vue?vue&type=template&id=0cffdc9a&"
import script from "./OfficesLogIn.vue?vue&type=script&lang=js&"
export * from "./OfficesLogIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports